import React from 'react';
import './cardPayments.less';

const CardPayments = () => {
  return (
    <div className='card-payments'>
      <div className='title'>Our team is working to launch card payments very soon</div>
      <div className='subtitle'>
        You’ll soon be able to pay by card directly — <br /> fast, safe, and easy.
      </div>
    </div>
  );
};

export default CardPayments;
